import { produce } from "immer";
import {
  FETCH_DEVICES,
  FETCH_DEVICES_SUCCESS,
  FETCH_DEVICES_FAILURE,
  TOGGLE_DEVICE_STATUS,
  TOGGLE_DEVICE_STATUS_SUCCESS,
  TOGGLE_DEVICE_STATUS_FAILURE,
} from "./constants";

export const initialState = {
  devices: [],
  isFetchingDevices: false,
  isToggling: false,
  togglingDeviceId: null,
};

const DeviceSettingsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_DEVICES:
        draft.isFetchingDevices = true;
        break;
      case FETCH_DEVICES_SUCCESS:
        draft.isFetchingDevices = false;
        draft.devices = action.payload;
        break;
      case FETCH_DEVICES_FAILURE:
        draft.isFetchingDevices = false;
        draft.devices = [];
        break;
      case TOGGLE_DEVICE_STATUS:
        draft.isToggling = true;
        draft.togglingDeviceId = action.payload?.id ?? null;
        break;
      case TOGGLE_DEVICE_STATUS_SUCCESS:
      case TOGGLE_DEVICE_STATUS_FAILURE:
        draft.isToggling = false;
        draft.togglingDeviceId = null;
        break;
      default:
        return state;
    }
  });

export default DeviceSettingsReducer;
